import React, { Component } from "react";

class Event01 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oid: props.match.params.oid,
    };
  }
  componentDidMount() {}

  renderGotoReg() {
    const imageClick = () => {
      window.open("/Register/" + this.state.oid);
    };
    return (
      <img
        style={{ width: "100%", marginBottom: -7 }}
        alt=""
        src="/event01_bottom.png"
        onClick={() => imageClick()}
      />
    );
  }

  render() {
    return (
      <div>
        <img
          style={{ width: "100%", marginBottom: -7 }}
          src="/event01_top.png"
          alt=""
        />
        {this.renderGotoReg()}
      </div>
    );
  }
}

export default Event01;
